import { render, staticRenderFns } from "./plantronics.vue?vue&type=template&id=1fa64291&"
import script from "./plantronics.vue?vue&type=script&lang=js&"
export * from "./plantronics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports